import { Reveal, MaskedLine, SectionNumber } from "./Reveal";
import { SECTORS } from "../data/sectors";

export const TFM = () => {
    const services = SECTORS["facility-management"].services;
    return (
        <section
            id="solutions"
            data-testid="tfm-section"
            className="relative py-28 md:py-36"
        >
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <SectionNumber n="03" label="Featured Capability" />
                <div className="mb-14 flex flex-wrap items-end justify-between gap-8">
                    <h2 className="font-display max-w-3xl text-5xl font-light leading-[1.06] tracking-tighter text-[#0E1112] sm:text-6xl lg:text-7xl">
                        <MaskedLine>Total Facility Management.</MaskedLine>
                        <MaskedLine delay={0.15} className="text-[#C8102E]">
                            Every service. One partner.
                        </MaskedLine>
                    </h2>
                    <Reveal delay={0.2} className="max-w-sm">
                        <p className="text-base leading-relaxed text-[#45543F]">
                            Hard and soft services under one contract, one SLA,
                            one line of accountability.
                        </p>
                    </Reveal>
                </div>

                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((s, i) => (
                        <Reveal key={s.name} delay={i * 0.07} className="h-full">
                            <article
                                data-testid={`tfm-service-${i + 1}`}
                                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#DCE5D4] bg-white transition-[border-color,transform,box-shadow] duration-400 hover:-translate-y-1.5 hover:border-[#598B3B]/50 hover:shadow-[0_18px_40px_rgba(89,139,59,0.1)]"
                            >
                                <div className="h-44 overflow-hidden">
                                    <img
                                        src={s.img}
                                        alt={s.name}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <h3 className="font-display text-xl font-semibold leading-snug tracking-tight text-[#0E1112]">
                                        {s.name}
                                    </h3>
                                    <p className="mt-2 text-sm leading-relaxed text-[#5C6B57]">
                                        {s.desc}
                                    </p>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
